import { Close } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";

import { getSettlementMedicalAmountFieldSx } from "../../../style/styles";

import AddCustomMedicalItemField from "./AddCustomMedicalItemField";

export default function AddCustomMedicalItemAmountField({ value, onChange }) {
  return (
    <div className="flex w-full gap-4">
      <AddCustomMedicalItemField label="Amount">
        <TextField
          className="w-full"
          size="small"
          value={value}
          onChange={(event) => onChange("settledAmount", event.target.value)}
          placeholder="Enter amount"
          sx={getSettlementMedicalAmountFieldSx()}
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
            endAdornment: value ? (
              <InputAdornment position="end" className="p-2">
                <IconButton edge="end" size="small" onClick={() => onChange("settledAmount", "")}>
                  <Close fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />
      </AddCustomMedicalItemField>
    </div>
  );
}
